var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var AIChatController = {
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/aichat/send" and http method "POST" to call the back-end.
    
        * @param {ChatRequest} request
        * @returns {ExtendedDataCollection<string, string>}
    ******************************************************************************************************/
    Send: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("request", JSON.stringify(data.request));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/aichat/send", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/aichat/cms/send" and http method "POST" to call the back-end.
    
        * @param {ChatRequest} request
        * @returns {ExtendedDataCollection<string, string>}
    ******************************************************************************************************/
    CmsSend: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("request", JSON.stringify(data.request));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/aichat/cms/send", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/aichat/playlist" and http method "POST" to call the back-end.
    
        * @param {ChatRequest} request
        * @param {PlaylistUploadDto} playlist
        * @returns {PlaylistDownloadDto}
    ******************************************************************************************************/
    Playlist: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("request", JSON.stringify(data.request));
        if (data.playlist !== undefined)
            fd.append("playlist", JSON.stringify(data.playlist));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/aichat/playlist", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=AIChatController.js.map